exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buildSection__navigation__pages.ui.list{padding-top:15px;padding-bottom:40px}", ""]);

